import Box from '@mui/material/Box';
import { useAuth } from "../auth";


export default function Login() {

    const {
        isAuthenticated,
      } = useAuth();


    return (
        <Box sx={{ height: `auto`, width: '100%' }}>
            { !isAuthenticated ? 
            "Login into admin by click on button in top menu."
                : "Welcome to Waulter Admin, choose action in left menu."}
        </Box>
      );
    }

